export const TrimWhiteSpace = (str) => {
  let result = str.replace(/\s/g, "");
  return result;
};
